import  { useEffect, useState } from "react";
// import { getCitationInfo } from "../../../../api/axiosInstanceApi";
import ExclusiveContentCitations from "./ExclusiveContentCitations";

function TextCitation({ isLoading, citation, onCitationClick }: any) {
  //this citation is first style of citation 
  const [citationRes, setCitationRes] = useState<any>();

  const getTitleAuthor = async (fileName: string) => {
    // const seedFileInfoRes = await getCitationInfo(fileName);
    // setCitationRes(seedFileInfoRes.data);
  };
  useEffect(() => {
    getTitleAuthor(
      citation
        .split("/")
        .at(-1)
    );
  }, []);

  return (
    
    <>
      {/* {citationRes && citationRes.media_type === 'blog' ? (
        <a
          href={citationRes.link}
          target="_blank"
          rel="noopener noreferrer"
          className="cursor-pointer text-left block link_text_color hover:underline"
        >
          {citationRes.title} <i> by {citationRes.author}</i>{" "}
        </a>
      ) : citationRes && citationRes.media_type == 'exclusive' ? (
        <ExclusiveContentCitations
          isLoading={isLoading}
          citation={citationRes}
          onCitationClick={onCitationClick}
        ></ExclusiveContentCitations>
      ) : (
        
      )} */}
      {citation}
    </>
  );
}

export default TextCitation;
